import IValidateRequisitosViagemResponse from '../entities/IValidateRequisitosViagemResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IValidateRequisitosViagem {
  execute(frotistaId: number): Promise<any>
}

export default class ValidateRequisitosViagemImpl
  implements IValidateRequisitosViagem
{
  constructor(private readonly userRepository: IUserRepository) {}
  public async execute(frotistaId: number): Promise<any> {
    return await this.userRepository.validateRequisitosViagem(frotistaId)
  }
}
